import Form from './Form'
import Places from '../services/Places'
import StorageService from '../services/StorageService'
import Cmd from '../utils/Cmd'
import Config from '../config'
import isNil from '../utils/isNil'
import {fieldError, isBlank} from '../utils/Validation'
const { keys, assign } = Object

const addressError = fieldError("deliveryAddress")

const fieldDefs = {
  'street': {},
  'streetNumber': {},
  'city': {},
  'postCode':{},
  'latitude': {},
  'longitude': {},
  'aptNumber': {},
  'floor': {},
  'country': {},
  'extra': {}
}

const fieldNames = keys(fieldDefs)

const validate = (address) => {
  const config = Config.address[address.country]
  // check required fields
  return config.requiredFields.reduce( ( errors, field) => {
    if (isBlank(address[field])) {
      return assign({}, errors, { [field] : [addressError(field, 'blank') ] })
    } else {
      return errors
    }
  }, {})
}

const AddressForm = Form({ formFields: fieldDefs, validate: validate  })

const hasLatLng = (address) => !isNil(address.longitude) && !isNil(address.latitude)


const init = ({ address, afterSubmit }) => {
  const [form, formCmd] = AddressForm.init({ model: address, afterSubmit })
  return  [
    assign({}, { geoCoding: false, errors: [] }, form ),
    Cmd.batch(
      formCmd,
      (form.valid && !hasLatLng(address)) ? Cmd.of(geoCode(address)) : Cmd.none
    )
  ]
}


const geoCode = (address) => (dispatch, getState) => {
  dispatch({ type: "GEOCODING_START" })
  Places.geoCode(address, (result, status) =>
    dispatch({ type: "GEOCODING_RESULT", result, status })
  )
}

const storeAddress = (address) => (dispatch, getState) =>
  StorageService.setJSONItem('deliveryAddress', address)

const isGeocoded = (field) => ['street', 'city', 'streetNumber'].indexOf(field) != -1


const update = (state, action) => {
  switch (action.type) {
    case "GEOCODING_START": {
      const [newState, formCmd] = AddressForm.update(state, { type: "SET_VALUES", values: { latitude: null, longitude: null } })
      return [
        assign({}, state, newState, { geoCoding: true, errors: [] }),
        formCmd
      ]
    }
    case "GEOCODING_RESULT": {
      console.log("Gecoding returned: ", action);
      if (action.result) {
        const [newState, formCmd] = AddressForm.update(state, { type: "SET_VALUES", values:
          { latitude: action.result.latitude
          , longitude: action.result.longitude
          }
        })
        return [
          assign({}, state, newState, { geoCoding: false, errors: [] } ),
          Cmd.of(storeAddress(newState.model))
        ]
      } else {
        return [
          assign({}, state, { geoCoding: false, errors: [I18n.t('delivery.geocoding_error')] }),
          Cmd.none
        ]
      }
    }
    case "FIELD_ACTION": {
      const [newState, formCmd] = AddressForm.update(state, action)
      const address = newState.model
      let cmd = Cmd.none
      if (action.payload.type === "CHANGE") {
        const shouldGeoCode = isGeocoded(action.field) && newState.valid
        const saveCmd = Cmd.of(storeAddress(newState.model))
        cmd = shouldGeoCode ? Cmd.batch(saveCmd, Cmd.of(geoCode(address))) : saveCmd
      }
      return [
        assign({}, state, newState),
        Cmd.batch(formCmd, cmd)
      ]
    }
    default:
      return [state, Cmd.none]
  }
}


const view = ($element, state, dispatch) => {
  const country = state.model.country
  const config = Config.address[country]
  //TODO: a hacky, finicky, fragile way of hiding postCode and also resizing city
  if (config.requiredFields.indexOf('postCode') == -1) {
    $(".js-post-code-wrapper").addClass('hide')
  }

  AddressForm.view($element, state, dispatch)

  if (state.geoCoding) {
    $(".js-geocoding-in-progress").removeClass("hide")
    $element.find('.js-geocoding-errors').addClass("hide")
  } else {
    $(".js-geocoding-in-progress").addClass("hide")
    if (state.errors.length > 0) {
      $element.find('.js-geocoding-errors').removeClass('hide').text(state.errors.join(", "))
    } else {
      $element.find('.js-geocoding-errors').addClass('hide').text("")
    }
  }

}

export default {
  init,
  update,
  view
}
